import type { SupportedCurrentEditions } from '@atlassian/confluence-end-user-upgrade-request-modal';

import { ConfluenceEdition } from '@confluence/session-data/entry-points/SiteInformationQuery.ts';

type SupportedConfluenceCurrentEditions = Extract<
	ConfluenceEdition,
	ConfluenceEdition.FREE | ConfluenceEdition.STANDARD
>;

const supportedCurrentEditionsMap: Record<
	SupportedConfluenceCurrentEditions,
	SupportedCurrentEditions
> = {
	[ConfluenceEdition.FREE]: 'free',
	[ConfluenceEdition.STANDARD]: 'standard',
};

const isSupportedEdition = (
	edition: ConfluenceEdition,
): edition is SupportedConfluenceCurrentEditions => {
	return edition in supportedCurrentEditionsMap;
};

/**
 * Maps a Confluence edition to a supported current edition.
 * @param edition - The Confluence edition (`FREE`, `STANDARD`) to map.
 * @returns The supported current edition (`free`, `standard`), or undefined if the edition is not supported.
 */
export const mapConfluenceEditionToSupportedCurrentEdition = (
	edition: ConfluenceEdition | null,
): SupportedCurrentEditions | undefined => {
	if (!edition || !isSupportedEdition(edition)) {
		return undefined;
	}
	return supportedCurrentEditionsMap[edition];
};
